import { UserProfile } from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'

export const getProfile = () => client.get<ResponseSuccess<UserProfile>>('v1/users/me/profile')

export const updateProfile = async (
  params: Pick<UserProfile, 'profile_image_file_name' | 'phone_number_cell'>
) => await client.patch('v1/users/me', params)
